import { ChangeEvent, memo } from 'react'
import { cn } from '@global/utils/tailwind'

interface RadioProps {
  id?: string
  name?: string
  value: string
  checked: boolean
  disabled?: boolean
  className?: string
  containerClassName?: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const Radio = memo(
  ({
    id,
    name,
    value,
    checked,
    disabled = false,
    className,
    containerClassName,
    onChange,
  }: RadioProps) => (
    <div className={cn('relative flex items-center cursor-pointer', containerClassName)}>
      <input
        id={id}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        type="radio"
        className={cn(
          'peer size-[14px] appearance-none rounded-full border checked:border-4 transition-all',
          { 'cursor-pointer border-cv-blue-200 checked:border-cv-primary': !disabled },
          { 'cursor-not-allowed': disabled },
          className,
        )}
      />
    </div>
  ),
)

Radio.displayName = 'Radio'
